<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" id="ahalf1" title="Half Title">
<p class="halftitle"><span class="right_1" epub:type="pagebreak" id="page_xiii" title="xiii">JÓN LEIFS AND THE</span></p>
<p class="halftitle2">MUSICAL INVENTION OF</p>
<p class="halftitle1">ICELAND<span class="right_1" epub:type="pagebreak" id="page_xiv" title="xiv"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253044075_Halftitle_1.vue?e67b7116